// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 40px 80px;
}

.cart-page h1 {
  font-family: var(--font-display);
  font-size: clamp(36px, 6vw, 64px);
  color: var(--gold);
  text-transform: uppercase;
  margin-bottom: 32px;
}

.cart-content {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 32px;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cart-item {
  display: grid;
  grid-template-columns: 100px 1fr auto auto auto;
  gap: 16px;
  align-items: center;
  background: rgba(255, 255, 255, 0.4);
  padding: 16px;
  border-radius: 12px;
}

.cart-item-image {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #ddd5c7;
}

.cart-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cart-item-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cart-item-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--dark);
}

.cart-item-name:hover {
  color: var(--gold);
}

.cart-item-category {
  font-size: 14px;
  color: var(--text-light);
}

.cart-item-price {
  font-size: 16px;
  color: var(--gold);
  font-weight: 600;
}

.cart-item-quantity {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 2px solid var(--border);
  border-radius: 8px;
  padding: 4px 8px;
}

.cart-item-quantity button {
  width: 28px;
  height: 28px;
  background-color: var(--dark);
  color: var(--bg);
  border-radius: 4px;
  font-size: 16px;
}

.cart-item-quantity button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cart-item-quantity span {
  font-size: 16px;
  font-weight: 600;
  min-width: 30px;
  text-align: center;
}

.cart-item-total {
  font-size: 18px;
  font-weight: 700;
  color: var(--dark);
  min-width: 80px;
  text-align: right;
}

.cart-item-remove {
  width: 32px;
  height: 32px;
  background-color: transparent;
  color: var(--text-light);
  font-size: 28px;
  line-height: 1;
  border-radius: 4px;
}

.cart-item-remove:hover {
  background-color: #fee;
  color: var(--error);
}

.cart-summary {
  position: sticky;
  top: 120px;
  height: fit-content;
}

.cart-summary h2 {
  font-family: var(--font-body);
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
}

.summary-row.total {
  font-size: 20px;
  font-weight: 700;
  color: var(--gold);
  border-bottom: none;
  padding-top: 16px;
}

.checkout-btn {
  width: 100%;
  margin-top: 24px;
  padding: 16px;
  font-size: 18px;
}

.continue-shopping {
  display: block;
  text-align: center;
  margin-top: 16px;
  color: var(--gold);
  font-weight: 500;
}

.continue-shopping:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .cart-page {
    padding: 16px 16px 60px;
  }

  .cart-content {
    grid-template-columns: 1fr;
  }

  .cart-item {
    grid-template-columns: 80px 1fr;
    gap: 12px;
    position: relative;
  }

  .cart-item-image {
    width: 80px;
    height: 80px;
  }

  .cart-item-quantity {
    grid-column: 1 / -1;
    width: fit-content;
  }

  .cart-item-total {
    grid-column: 1 / -1;
    text-align: left;
  }

  .cart-item-remove {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
  }

  .cart-summary {
    position: static;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Cart.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;IAC/B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".cart-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px 40px 80px;\n}\n\n.cart-page h1 {\n  font-family: var(--font-display);\n  font-size: clamp(36px, 6vw, 64px);\n  color: var(--gold);\n  text-transform: uppercase;\n  margin-bottom: 32px;\n}\n\n.cart-content {\n  display: grid;\n  grid-template-columns: 1fr 360px;\n  gap: 32px;\n}\n\n.cart-items {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cart-item {\n  display: grid;\n  grid-template-columns: 100px 1fr auto auto auto;\n  gap: 16px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.4);\n  padding: 16px;\n  border-radius: 12px;\n}\n\n.cart-item-image {\n  width: 100px;\n  height: 100px;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #ddd5c7;\n}\n\n.cart-item-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.cart-item-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cart-item-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--dark);\n}\n\n.cart-item-name:hover {\n  color: var(--gold);\n}\n\n.cart-item-category {\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n.cart-item-price {\n  font-size: 16px;\n  color: var(--gold);\n  font-weight: 600;\n}\n\n.cart-item-quantity {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 2px solid var(--border);\n  border-radius: 8px;\n  padding: 4px 8px;\n}\n\n.cart-item-quantity button {\n  width: 28px;\n  height: 28px;\n  background-color: var(--dark);\n  color: var(--bg);\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.cart-item-quantity button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cart-item-quantity span {\n  font-size: 16px;\n  font-weight: 600;\n  min-width: 30px;\n  text-align: center;\n}\n\n.cart-item-total {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--dark);\n  min-width: 80px;\n  text-align: right;\n}\n\n.cart-item-remove {\n  width: 32px;\n  height: 32px;\n  background-color: transparent;\n  color: var(--text-light);\n  font-size: 28px;\n  line-height: 1;\n  border-radius: 4px;\n}\n\n.cart-item-remove:hover {\n  background-color: #fee;\n  color: var(--error);\n}\n\n.cart-summary {\n  position: sticky;\n  top: 120px;\n  height: fit-content;\n}\n\n.cart-summary h2 {\n  font-family: var(--font-body);\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.summary-row.total {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--gold);\n  border-bottom: none;\n  padding-top: 16px;\n}\n\n.checkout-btn {\n  width: 100%;\n  margin-top: 24px;\n  padding: 16px;\n  font-size: 18px;\n}\n\n.continue-shopping {\n  display: block;\n  text-align: center;\n  margin-top: 16px;\n  color: var(--gold);\n  font-weight: 500;\n}\n\n.continue-shopping:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .cart-page {\n    padding: 16px 16px 60px;\n  }\n\n  .cart-content {\n    grid-template-columns: 1fr;\n  }\n\n  .cart-item {\n    grid-template-columns: 80px 1fr;\n    gap: 12px;\n    position: relative;\n  }\n\n  .cart-item-image {\n    width: 80px;\n    height: 80px;\n  }\n\n  .cart-item-quantity {\n    grid-column: 1 / -1;\n    width: fit-content;\n  }\n\n  .cart-item-total {\n    grid-column: 1 / -1;\n    text-align: left;\n  }\n\n  .cart-item-remove {\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    transform: translateY(-50%);\n  }\n\n  .cart-summary {\n    position: static;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
